export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14024.4a267927.jpg";